import Vue from 'vue'
import Router from 'vue-router'
// import store from './store'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: { requiresAuth: false, gtm: 'login' }
    },
    {
      path: '/',
      name: '',
      component: () => import('@/views/Index/Layout.vue'),
      children: [
        { path: '', name: 'Index', component: () => import('@/views/Index/Index.vue'), meta: { requiresAuth: true, gtm: 'Index' } },
        { path: 'records', name: 'Records', component: () => import('@/views/Index/Records.vue'), meta: { requiresAuth: true, gtm: 'Records' } }
      ],
      // component: () => import('@/views/Index.vue'),
      meta: { requiresAuth: true, gtm: 'Index' }
    },
    {
      path: '/',
      name: '',
      component: () => import('@/views/Generate/Layout.vue'),
      children: [
        { path: 'intro/:lang?', name: 'intro', component: () => import('@/views/Generate/Intro.vue'), meta: { requiresAuth: true, gtm: 'intro' } },
        { path: 'intro_speech', name: 'introSpeech', component: () => import('@/views/Generate/Intro.vue'), meta: { requiresAuth: true, gtm: 'IntroSpeech' } },

        { path: 'AI/:promptId?', name: 'ChatAI', component: () => import('@/views/Generate/Chat.vue'), meta: { requiresAuth: true, gtm: 'ChatAI' } },
        { path: 'AI/jp/:promptId?', name: 'ChatAIJp', component: () => import('@/views/Generate/Chat.vue'), meta: { requiresAuth: true, gtm: 'ChatAIJp' } },

        { path: 'view/:lang', name: 'viewChat', component: () => import('@/views/Generate/Chat.vue'), meta: { requiresAuth: true, gtm: 'viewChat' } },

        { path: 'generate/:aiType?', name: 'SpeechAI', component: () => import('@/views/Generate/Speech.vue'), meta: { requiresAuth: true, gtm: 'SpeechAI' } },
        { path: 'generate/jp/:aiType?', name: 'SpeechAIJp', component: () => import('@/views/Generate/Speech.vue'), meta: { requiresAuth: true, gtm: 'SpeechAIJp' } },

        { path: 'generate/view/:aiType/:promptId?', name: 'viewGenerate', component: () => import('@/views/Generate/Speech.vue'), meta: { requiresAuth: true, gtm: 'viewSpeech' } }
      ]
    },
    {
      path: '/GEPT',
      name: '',
      component: () => import('@/views/GEPT/Layout.vue'),
      children: [
        { path: 'overview', name: 'GEPT_Overview', component: () => import('@/views/GEPT/Overview.vue'), meta: { requiresAuth: true, gtm: 'GEPT_Overview' } },

        { path: 'p/:select_id/:practice_type?', name: 'practice_speaking', component: () => import('@/views/GEPT/Practice.vue'), meta: { requiresAuth: true, gtm: 'practice_speaking' } },
        { path: 'f/:select_id/:practice_type?', name: 'formal_exam', component: () => import('@/views/GEPT/Practice.vue'), meta: { requiresAuth: true, gtm: 'formal_exam' } },

        { path: 'report/:select_id/:record_id', name: 'gept_report_part', component: () => import('@/views/GEPT/Report.vue'), meta: { requiresAuth: true, gtm: 'gept_report_part' } },
        { path: 'report_formal_exam/:record_id', name: 'gept_report_formal', component: () => import('@/views/GEPT/Report.vue'), meta: { requiresAuth: true, gtm: 'gept_report/formal' } }
      ]
    },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('./views/NotFoundPage.vue'), meta: { requiresAuth: true, gtm: 'NotFoundPage' } }
  ],
})

  const originalPush = Router.prototype.push
  Router.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
  }

  const originalReplace = Router.prototype.replace
  Router.prototype.replace = function replace (location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)
  }
export default router